import { AccessTime, CalendarMonth, Place } from "@mui/icons-material";
import moment from "moment";

const PlaceDateTime = ({
  isOldVersion,
  place,
  isOnline,
  linkVicon,
  date,
  startTime,
  endTime,
}) => (
  <div className="w-full">
    <table className="table-fixed">
      <tbody>
        {place && (
          <tr>
            <td>
              <Place />
            </td>
            <td>
              {isOldVersion ? place : ""}
              {isOnline === true ? (
                <>
                  {" @ "}
                  <a
                    href={isOldVersion ? linkVicon : place}
                    target="_blank"
                    rel="noreferrer"
                    className="text-blue-500 hover:underline"
                  >
                    Link
                  </a>
                </>
              ) : (
                <>{isOldVersion ? "" : place}</>
              )}
            </td>
          </tr>
        )}
        <tr>
          <td>
            <CalendarMonth />
          </td>
          <td>{moment(date, "YYYY-MM-DD").format("ddd, D MMM YYYY")}</td>
        </tr>
        {startTime && (
          <tr>
            <td>
              <AccessTime />
            </td>
            <td>
              {moment(startTime, "HH:mm:ss").format("HH:mm")}
              {endTime &&
                ` - ${moment(endTime, "HH:mm:ss").format("HH:mm")} WIB`}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

export default PlaceDateTime;
